import Image from 'components/Image';
import React from 'react'
import { useState } from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';

const SlidesWrapper = styled.div`
    .slide_item{
        min-width: 100%;
        max-width: 100%;
        max-height: 450px;
        min-height: 450px;
        display: flex;
        align-items: center;
        img{
            width: 100%;
            max-height: 450px;
            object-fit: contain;
        }
    }
    .slide_list_item{
        min-width: 80px;
        max-width: 80px;
        max-height: 80px;
        min-height: 80px;
        cursor: pointer;
        display: flex !important;
        align-items: center;
        img{
            width: 100%;
            max-height: 80px;
            object-fit: contain;
        }
    }
    .list_img_des{
        max-width: 260px;
        display: flex;
        align-items: center;
        overflow-x: hidden;
    }
    .list_main{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`
const settings = {
    className: "slide_main b-grey2-1 mb-10",
    infinite: true,
    slidesToShow: 1,
    speed: 500,
    arrows: false,
};
const SlidesImage = ({ data }) => {
    const [nav1, setNav1] = useState();
    const [nav2, setNav2] = useState();

    return (
        <SlidesWrapper>
            <Slider asNavFor={nav2} ref={c => setNav1(c)} {...settings}>
                {
                    data.map((item, index) => (
                        <div key={index} className="slide_item">
                            <Image src={item.image_path} />
                        </div>
                    ))
                }
            </Slider>

            <div className='list_main'>
                <div className='list_img_des'>
                    <Slider
                        asNavFor={nav1}
                        ref={c => setNav2(c)}
                        swipeToSlide={true}
                        focusOnSelect={true}
                        arrows={false}
                        slidesToShow={data.length >= 2 ? 2 : 1}
                        variableWidth={true}
                        className="slide_children"
                    >
                        {
                            data.map((item, index) => (
                                <div key={index} className="slide_list_item mr-10 clickable b-grey2-1">
                                    <Image src={item.image_path} />
                                </div>
                            ))
                        }
                    </Slider>
                </div>
            </div>
        </SlidesWrapper>
    )
}

export default SlidesImage